import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@/components/ui/card';
import type { Highlight } from './HighlightsEditor';
interface HighlightsDisplayProps {
  highlights: Highlight[];
  position: 'top' | 'side';
}
export function HighlightsDisplay(t0) {
  const $ = _c(8);
  const {
    highlights,
    position
  } = t0;
  if (!highlights || highlights.length === 0) {
    return null;
  }
  if (position === "top") {
    let t1;
    if ($[0] !== highlights) {
      t1 = highlights.map(_temp);
      $[0] = highlights;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">{t1}</div>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== highlights) {
    t1 = highlights.map(_temp2);
    $[4] = highlights;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <div className="space-y-3">{t1}</div>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp2(highlight_0) {
  return <HighlightCard key={highlight_0.id} highlight={highlight_0} />;
}
function _temp(highlight) {
  return <HighlightCard key={highlight.id} highlight={highlight} />;
}
function HighlightCard(t0) {
  const $ = _c(10);
  const {
    highlight
  } = t0;
  let t1;
  if ($[0] !== highlight.title) {
    t1 = <p className="text-lg font-bold text-gray-900 tracking-tight">{highlight.title}</p>;
    $[0] = highlight.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== highlight.value) {
    t2 = <p className="text-4xl font-extrabold mt-2 text-primary">{highlight.value}</p>;
    $[2] = highlight.value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== highlight.details) {
    t3 = highlight.details && <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{highlight.details}</p>;
    $[4] = highlight.details;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <Card className="py-5 bg-gradient-to-br from-gray-50 to-white border-gray-200 shadow-md"><CardContent className="px-5 py-0">{t1}{t2}{t3}</CardContent></Card>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}